import { API_ROUTES } from '@/constants/apiRoutes';
import { IdempotentRequest } from '@/types/common';
import {
  CreateTransactionRequest,
  CreateTransactionResponse,
  TransactionRequestResponse,
  TransactionType,
  TransactionRequestDetails,
} from '@/types/transactionRequests';
import { AccountOrigins } from '@/types/transactions';
import { api, formatCurrencyForPost } from '@/utils/api';

export const getTransactionRequestListService = async (queryParams: string) => {
  const { data } = await api<TransactionRequestResponse>({
    url: `${API_ROUTES.TRANSACTION_REQUEST}?${queryParams}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const getTransactionRequestDetailsService = async (uuid: string) => {
  const { data } = await api<TransactionRequestDetails>({
    url: `${API_ROUTES.TRANSACTION_REQUEST}${uuid}`,
    method: 'get',
    version: 2,
  });

  return data;
};

function getAccountOrigins(transactionType?: TransactionType) {
  let toAccountOrign: AccountOrigins;
  let fromAccountOrigin: AccountOrigins;
  switch (transactionType) {
    case 'deposit':
      toAccountOrign = 'internal';
      fromAccountOrigin = 'external';
      break;
    case 'withdrawal':
      toAccountOrign = 'external';
      fromAccountOrigin = 'internal';
      break;
    case 'wire':
      toAccountOrign = 'third party wire recipient';
      fromAccountOrigin = 'internal';
      break;
    default:
      toAccountOrign = 'internal';
      fromAccountOrigin = 'internal';
  }

  return {
    toAccountOrign,
    fromAccountOrigin,
  };
}

export const createTransactionRequestService = async ({
  fromAccountId,
  toAccountId,
  amount,
  transactionType,
  speed,
  note,
  instructions,
  idempotencyKey,
  requestExceedingLimitException,
  skipCustomerReview,
  purpose,
  customerId,
}: IdempotentRequest<CreateTransactionRequest>) => {
  const { toAccountOrign, fromAccountOrigin } =
    getAccountOrigins(transactionType);

  const { data } = await api<CreateTransactionResponse>({
    url: `${API_ROUTES.TRANSACTION_REQUEST}`,
    method: 'post',
    data: {
      to_account: {
        id: toAccountId,
        origin: toAccountOrign,
      },
      from_account: {
        id: fromAccountId,
        origin: fromAccountOrigin,
      },
      type: speed ? speed : 'standard',
      amount: amount ? formatCurrencyForPost(amount) : '',
      note,
      instructions,
      consumer_id: customerId,
      request_exceeding_limit_exception:
        requestExceedingLimitException || false,
      skip_customer_review: skipCustomerReview || false,
      purpose: purpose || null,
    },
    version: 2,
    idempotencyKey,
  });

  return data;
};
